import { useState, useCallback } from "react";
import ActiveUsers from "../activeUsers/ActiveUsers";
import { useSelector } from "react-redux";

function ActiveUsersModal({ children }) {
  const [open, setOpen] = useState(false);

  const token = useSelector((state) => state.userReducer.token);
  const role = useSelector((state) => state.userReducer.role);

  const handleOpen = useCallback(() => setOpen(true), []);
  const handleClose = useCallback(() => setOpen(false), []);

  const canShowDrawer = token && (role === "super" || role === "operation" || role==="trafficManager");

  return (
    <>
      {children}

      {canShowDrawer && (
        <>
          {!open && (
            <button
              className="drawer fixed-button"
              type="button"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                handleOpen();
              }}
            >
              ClickMe Open Drawer
            </button>
          )}
          {open && (
            <ActiveUsers anchor="right" open={open} onClose={handleClose} />
          )}
        </>
      )}
    </>
  );
}

export default ActiveUsersModal;
